export const SET_APPS = 'SET_APPS';
export const setAppsAction = (apps) => ({
  type: SET_APPS,
  payload: apps,
});
